import { Injectable } from "@angular/core";
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";
import * as io from "socket.io-client";
import { environment } from "../../../environments/environment";

@Injectable()
export class SyncProgressService {
  private env: any = environment;

  constructor() {}

  watch(id: string): Observable<number> {
    let socket = io(this.env.socketUrl + "/sync-progress", {
      path: this.env.socketPath,
    });
    socket.emit("watchProgress", id);
    let subject = new Subject<number>();
    socket.on("progress", (x: number) => {
      subject.next(x);
    });
    return subject.startWith(0);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/sync-progress/sync-progress.service.ts